import { useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import { WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { workspaceByIdSelector } from '@futrli/shared-services';

import { StoreState } from '../core/redux-utils/types';

export const usePermissions = () => {
  const { workspaceId: tempWorkspaceId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const { normalised } = useStore<StoreState>().getState();

  const currentWorkspace = workspaceByIdSelector(normalised, workspaceId) as WorkspacesListingItem;
  const storedPermissions = currentWorkspace ? currentWorkspace.permissions : null;

  return storedPermissions;
};
